import { storeToRefs } from 'pinia'
import { watch } from 'vue'

import { FEATURE_FLAG } from '@/composables/featureFlagCatalog'
import { useFeatureFlag } from '@/composables/useFeatureFlag'
import { useNotificationsQuery } from '@/gql/platform-api'
import { $can } from '@/services/roles'
import { useNotificationCenterStore } from '@/stores'

export const useNotificationUnreadCount = () => {
  const store = useNotificationCenterStore()
  const { unreadCount } = storeToRefs(store)

  const { enabled: feedEnabled } = useFeatureFlag(FEATURE_FLAG.NOTIFICATIONS.FEED_RELEASE)
  const { enabled: centerEnabled } = useFeatureFlag(FEATURE_FLAG.NOTIFICATIONS.CENTER_RELEASE)

  const { result } = useNotificationsQuery({ first: 0 }, () => ({
    clientId: 'platformApi',
    fetchPolicy: 'network-only',
    enabled: (feedEnabled.value || centerEnabled.value) && $can('manageReviews', { for: 'User' }),
  }))

  watch(
    result,
    (v) => {
      if (!v?.public) return
      store.syncUnreadCountFromQuery(v.public.notifications.unreadCount)
    },
    { immediate: true },
  )

  return { unreadCount }
}
